import { Page } from '@/shared/models/page.model';

/** Campo-alvo da pesquisa de atividades (valor enviado ao backend). */
export enum EComissaoAtividadeTipoPesquisaFiltro {
    TODOS = 'TODOS',
    CODIGO_ATIVIDADE = 'CODIGO_ATIVIDADE',
    NUMERO_ATIVIDADE = 'NUMERO_ATIVIDADE',
    CODIGO_REUNIAO = 'CODIGO_REUNIAO',
    CODIGO_COMISSAO = 'CODIGO_COMISSAO',
    CODIGO_PROTOCOLO = 'CODIGO_PROTOCOLO'
}

export interface ComissaoAtividadeFiltroRequest {
    tipoPesquisa?: EComissaoAtividadeTipoPesquisaFiltro;
    codigoPesquisa?: number;
    /** UF da comissão (CCT_COMISSAO_CT.UF_SG_UF_EE); nulo = todas as UFs. */
    ufSgUf?: string;
    dataInicioAbertura?: string;
    dataFimAbertura?: string;
    dataInicioEncerramento?: string;
    dataFimEncerramento?: string;
    descricaoTarefa?: string;
    idSituacaoTarefa?: number;
    idTipoComissaoCt?: number;
    idEstruturaOrganizacional?: number;
    idProtocolo?: number;
    idSolicitanteResponsavel?: number;
    ufSolicitanteResponsavel?: string;
}

export interface ComissaoAtividadeResponsavelFiltroRequest {
    idReuniao?: number;
    idEstruturaOrganizacional?: number;
    nmSolicitante?: string;
    ufSgUf?: string;
}

export interface ComissaoAtividadeResponsavelResponse {
    nmSolicitante?: string;
    idSolicitante?: number;
    ufSgUf?: string;
}

export interface ComissaoSituacaoAtividadeResponse {
    idSituacaoTarefa?: number;
    dsSituacaoTarefa?: string;
}

export interface ComissaoProximoCodigoAtividadeResponse {
    idTarefa?: number;
    codigoTarefa?: string;
}

export interface ComissaoAtividadeResponse {
    codigoTarefa?: string;
    idTarefa?: number;
    dsTarefa?: string;
    dtInicio?: string;
    dtTermino?: string;
    dtUltimaAlteracao?: string;
    idEstruturaOrganizacional?: number;
    dsEstruturaOrganizacional?: string;
    idProtocolo?: number;
    numeroProtocolo?: string;
    codigoReuniao?: string;
    idReuniao?: number;
    idSituacaoTarefa?: number;
    dsSituacaoTarefa?: string;
    idSolicitanteAlteracao?: number;
    idSolicitanteResponsavel?: number;
    numeroTarefa?: string;
    nuSequencialTarefa?: number;
    sgUfSolicitanteAlteracao?: string;
    sgUfSolicitanteResponsavel?: string;
    txObservacao?: string;
    idTipoComissaoCt?: number;
    nmSolicitanteResponsavel?: string;
}

export type ComissaoAtividadePageResponse = Page<ComissaoAtividadeResponse>;

export interface ComissaoAtividadeSalvarRequest {
    idEstruturaOrganizacional?: number;
    idSolicitanteResponsavel?: number;
    sgUfSolicitanteResponsavel?: string;
    dsTarefa?: string;
    txObservacao?: string;
    dtInicio?: string;
    dtTermino?: string;
    idSituacaoTarefa?: number;
    idReuniao?: number;
    idProtocolo?: number;
}
